// ===================== TYPES =====================
export const SET_NOTE_FRAIS_REQUEST_LOADING = "SET_NOTE_FRAIS_REQUEST_LOADING";
export const CLEAR_NOTE_FRAIS_REQUEST_MESSAGE = "CLEAR_NOTE_FRAIS_REQUEST_MESSAGE";

// Mine
export const GET_MY_NOTE_FRAIS_REQUESTS_REQUEST = "GET_MY_NOTE_FRAIS_REQUESTS_REQUEST";
export const GET_MY_NOTE_FRAIS_REQUESTS_SUCCESS = "GET_MY_NOTE_FRAIS_REQUESTS_SUCCESS";
export const GET_MY_NOTE_FRAIS_REQUESTS_FAIL = "GET_MY_NOTE_FRAIS_REQUESTS_FAIL";

// Create
export const CREATE_NOTE_FRAIS_REQUEST_REQUEST = "CREATE_NOTE_FRAIS_REQUEST_REQUEST";
export const CREATE_NOTE_FRAIS_REQUEST_SUCCESS = "CREATE_NOTE_FRAIS_REQUEST_SUCCESS";
export const CREATE_NOTE_FRAIS_REQUEST_FAIL = "CREATE_NOTE_FRAIS_REQUEST_FAIL";

// Cancel
export const CANCEL_NOTE_FRAIS_REQUEST_REQUEST = "CANCEL_NOTE_FRAIS_REQUEST_REQUEST";
export const CANCEL_NOTE_FRAIS_REQUEST_SUCCESS = "CANCEL_NOTE_FRAIS_REQUEST_SUCCESS";
export const CANCEL_NOTE_FRAIS_REQUEST_FAIL = "CANCEL_NOTE_FRAIS_REQUEST_FAIL";

// Update
export const UPDATE_NOTE_FRAIS_REQUEST_REQUEST = "UPDATE_NOTE_FRAIS_REQUEST_REQUEST";
export const UPDATE_NOTE_FRAIS_REQUEST_SUCCESS = "UPDATE_NOTE_FRAIS_REQUEST_SUCCESS";
export const UPDATE_NOTE_FRAIS_REQUEST_FAIL = "UPDATE_NOTE_FRAIS_REQUEST_FAIL";

// Manager inbox
export const GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST = "GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST";
export const GET_MANAGER_NOTE_FRAIS_INBOX_SUCCESS = "GET_MANAGER_NOTE_FRAIS_INBOX_SUCCESS";
export const GET_MANAGER_NOTE_FRAIS_INBOX_FAIL = "GET_MANAGER_NOTE_FRAIS_INBOX_FAIL";

// Manager decision
export const MANAGER_NOTE_FRAIS_DECISION_REQUEST = "MANAGER_NOTE_FRAIS_DECISION_REQUEST";
export const MANAGER_NOTE_FRAIS_DECISION_SUCCESS = "MANAGER_NOTE_FRAIS_DECISION_SUCCESS";
export const MANAGER_NOTE_FRAIS_DECISION_FAIL = "MANAGER_NOTE_FRAIS_DECISION_FAIL";

// Manager history
export const GET_MANAGER_NOTE_FRAIS_HISTORY_REQUEST = "GET_MANAGER_NOTE_FRAIS_HISTORY_REQUEST";
export const GET_MANAGER_NOTE_FRAIS_HISTORY_SUCCESS = "GET_MANAGER_NOTE_FRAIS_HISTORY_SUCCESS";
export const GET_MANAGER_NOTE_FRAIS_HISTORY_FAIL = "GET_MANAGER_NOTE_FRAIS_HISTORY_FAIL";

// Admin inbox
export const GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST = "GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST";
export const GET_ADMIN_NOTE_FRAIS_INBOX_SUCCESS = "GET_ADMIN_NOTE_FRAIS_INBOX_SUCCESS";
export const GET_ADMIN_NOTE_FRAIS_INBOX_FAIL = "GET_ADMIN_NOTE_FRAIS_INBOX_FAIL";

// Admin decision
export const ADMIN_NOTE_FRAIS_DECISION_REQUEST = "ADMIN_NOTE_FRAIS_DECISION_REQUEST";
export const ADMIN_NOTE_FRAIS_DECISION_SUCCESS = "ADMIN_NOTE_FRAIS_DECISION_SUCCESS";
export const ADMIN_NOTE_FRAIS_DECISION_FAIL = "ADMIN_NOTE_FRAIS_DECISION_FAIL";

// Admin history
export const GET_ADMIN_NOTE_FRAIS_HISTORY_REQUEST = "GET_ADMIN_NOTE_FRAIS_HISTORY_REQUEST";
export const GET_ADMIN_NOTE_FRAIS_HISTORY_SUCCESS = "GET_ADMIN_NOTE_FRAIS_HISTORY_SUCCESS";
export const GET_ADMIN_NOTE_FRAIS_HISTORY_FAIL = "GET_ADMIN_NOTE_FRAIS_HISTORY_FAIL";

// Remboursement
export const MARQUER_NOTE_FRAIS_REMBOURSE_REQUEST = "MARQUER_NOTE_FRAIS_REMBOURSE_REQUEST";
export const MARQUER_NOTE_FRAIS_REMBOURSE_SUCCESS = "MARQUER_NOTE_FRAIS_REMBOURSE_SUCCESS";
export const MARQUER_NOTE_FRAIS_REMBOURSE_FAIL = "MARQUER_NOTE_FRAIS_REMBOURSE_FAIL";

// En attente remboursement
export const GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST = "GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST";
export const GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_SUCCESS = "GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_SUCCESS";
export const GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_FAIL = "GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_FAIL";

// By ordre mission
export const GET_NOTE_FRAIS_BY_ORDRE_MISSION_REQUEST = "GET_NOTE_FRAIS_BY_ORDRE_MISSION_REQUEST";
export const GET_NOTE_FRAIS_BY_ORDRE_MISSION_SUCCESS = "GET_NOTE_FRAIS_BY_ORDRE_MISSION_SUCCESS";
export const GET_NOTE_FRAIS_BY_ORDRE_MISSION_FAIL = "GET_NOTE_FRAIS_BY_ORDRE_MISSION_FAIL";

// ===================== HELPERS =====================
export const normalizeError = (err, fallback = "Erreur") => {
    if (!err) return fallback;
    if (typeof err === "string") return err;
    if (err?.message) return String(err.message);
    if (err?.error) return String(err.error);
    try {
        return JSON.stringify(err);
    } catch {
        return fallback;
    }
};

// ===================== COMMON =====================
export const setNoteDeFraisRequestLoading = (value) => ({
    type: SET_NOTE_FRAIS_REQUEST_LOADING,
    payload: !!value,
});

export const clearNoteDeFraisRequestMessage = () => ({
    type: CLEAR_NOTE_FRAIS_REQUEST_MESSAGE,
});

// ===================== MINE =====================
export const getMyNoteDeFraisRequestsRequest = (options = {}) => ({
    type: GET_MY_NOTE_FRAIS_REQUESTS_REQUEST,
    meta: options,
});
export const getMyNoteDeFraisRequestsSuccess = (data) => ({
    type: GET_MY_NOTE_FRAIS_REQUESTS_SUCCESS,
    payload: data,
});
export const getMyNoteDeFraisRequestsFail = (error) => ({
    type: GET_MY_NOTE_FRAIS_REQUESTS_FAIL,
    payload: error,
});

// ===================== CREATE =====================
export const createNoteDeFraisRequestRequest = (payload) => ({
    type: CREATE_NOTE_FRAIS_REQUEST_REQUEST,
    payload,
});
export const createNoteDeFraisRequestSuccess = (data) => ({
    type: CREATE_NOTE_FRAIS_REQUEST_SUCCESS,
    payload: data,
});
export const createNoteDeFraisRequestFail = (error) => ({
    type: CREATE_NOTE_FRAIS_REQUEST_FAIL,
    payload: error,
});

// ===================== CANCEL =====================
export const cancelNoteDeFraisRequestRequest = (id) => ({
    type: CANCEL_NOTE_FRAIS_REQUEST_REQUEST,
    payload: { id },
});
export const cancelNoteDeFraisRequestSuccess = (data) => ({
    type: CANCEL_NOTE_FRAIS_REQUEST_SUCCESS,
    payload: data,
});
export const cancelNoteDeFraisRequestFail = (error) => ({
    type: CANCEL_NOTE_FRAIS_REQUEST_FAIL,
    payload: error,
});

// ===================== UPDATE =====================
export const updateNoteDeFraisRequestRequest = (id, payload) => ({
    type: UPDATE_NOTE_FRAIS_REQUEST_REQUEST,
    payload: { id, ...payload },
});
export const updateNoteDeFraisRequestSuccess = (data) => ({
    type: UPDATE_NOTE_FRAIS_REQUEST_SUCCESS,
    payload: data,
});
export const updateNoteDeFraisRequestFail = (error) => ({
    type: UPDATE_NOTE_FRAIS_REQUEST_FAIL,
    payload: error,
});

// ===================== MANAGER INBOX =====================
export const getManagerNoteDeFraisInboxRequest = (meta = {}) => ({
    type: GET_MANAGER_NOTE_FRAIS_INBOX_REQUEST,
    meta,
});
export const getManagerNoteDeFraisInboxSuccess = (data) => ({
    type: GET_MANAGER_NOTE_FRAIS_INBOX_SUCCESS,
    payload: data,
});
export const getManagerNoteDeFraisInboxFail = (error) => ({
    type: GET_MANAGER_NOTE_FRAIS_INBOX_FAIL,
    payload: error,
});

// ===================== MANAGER DECISION =====================
export const managerNoteDeFraisDecisionRequest = (payload) => ({
    type: MANAGER_NOTE_FRAIS_DECISION_REQUEST,
    payload,
});
export const managerNoteDeFraisDecisionSuccess = (data) => ({
    type: MANAGER_NOTE_FRAIS_DECISION_SUCCESS,
    payload: data,
});
export const managerNoteDeFraisDecisionFail = (error) => ({
    type: MANAGER_NOTE_FRAIS_DECISION_FAIL,
    payload: error,
});

// ===================== MANAGER HISTORY =====================
export const getManagerNoteDeFraisHistoryRequest = (meta = {}) => ({
    type: GET_MANAGER_NOTE_FRAIS_HISTORY_REQUEST,
    meta,
});
export const getManagerNoteDeFraisHistorySuccess = (data) => ({
    type: GET_MANAGER_NOTE_FRAIS_HISTORY_SUCCESS,
    payload: data,
});
export const getManagerNoteDeFraisHistoryFail = (error) => ({
    type: GET_MANAGER_NOTE_FRAIS_HISTORY_FAIL,
    payload: error,
});

// ===================== ADMIN INBOX =====================
export const getAdminNoteDeFraisInboxRequest = (meta = {}) => ({
    type: GET_ADMIN_NOTE_FRAIS_INBOX_REQUEST,
    meta,
});
export const getAdminNoteDeFraisInboxSuccess = (data) => ({
    type: GET_ADMIN_NOTE_FRAIS_INBOX_SUCCESS,
    payload: data,
});
export const getAdminNoteDeFraisInboxFail = (error) => ({
    type: GET_ADMIN_NOTE_FRAIS_INBOX_FAIL,
    payload: error,
});

// ===================== ADMIN DECISION =====================
export const adminNoteDeFraisDecisionRequest = (payload) => ({
    type: ADMIN_NOTE_FRAIS_DECISION_REQUEST,
    payload,
});
export const adminNoteDeFraisDecisionSuccess = (data) => ({
    type: ADMIN_NOTE_FRAIS_DECISION_SUCCESS,
    payload: data,
});
export const adminNoteDeFraisDecisionFail = (error) => ({
    type: ADMIN_NOTE_FRAIS_DECISION_FAIL,
    payload: error,
});

// ===================== ADMIN HISTORY =====================
export const getAdminNoteDeFraisHistoryRequest = (meta = {}) => ({
    type: GET_ADMIN_NOTE_FRAIS_HISTORY_REQUEST,
    meta,
});
export const getAdminNoteDeFraisHistorySuccess = (data) => ({
    type: GET_ADMIN_NOTE_FRAIS_HISTORY_SUCCESS,
    payload: data,
});
export const getAdminNoteDeFraisHistoryFail = (error) => ({
    type: GET_ADMIN_NOTE_FRAIS_HISTORY_FAIL,
    payload: error,
});

// ===================== REMBOURSEMENT =====================
export const marquerNoteDeFraisRembourseeRequest = (payload) => ({
    type: MARQUER_NOTE_FRAIS_REMBOURSE_REQUEST,
    payload,
});
export const marquerNoteDeFraisRembourseeSuccess = (data) => ({
    type: MARQUER_NOTE_FRAIS_REMBOURSE_SUCCESS,
    payload: data,
});
export const marquerNoteDeFraisRembourseeFail = (error) => ({
    type: MARQUER_NOTE_FRAIS_REMBOURSE_FAIL,
    payload: error,
});

// ===================== EN ATTENTE REMBOURSEMENT =====================
export const getNoteDeFraisEnAttenteRemboursementRequest = () => ({
    type: GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_REQUEST,
});
export const getNoteDeFraisEnAttenteRemboursementSuccess = (data) => ({
    type: GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_SUCCESS,
    payload: data,
});
export const getNoteDeFraisEnAttenteRemboursementFail = (error) => ({
    type: GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_FAIL,
    payload: error,
});

// ===================== BY ORDRE MISSION =====================
export const getNoteDeFraisByOrdreMissionRequest = (ordreMissionId) => ({
    type: GET_NOTE_FRAIS_BY_ORDRE_MISSION_REQUEST,
    payload: { ordreMissionId },
});
export const getNoteDeFraisByOrdreMissionSuccess = (data) => ({
    type: GET_NOTE_FRAIS_BY_ORDRE_MISSION_SUCCESS,
    payload: data,
});
export const getNoteDeFraisByOrdreMissionFail = (error) => ({
    type: GET_NOTE_FRAIS_BY_ORDRE_MISSION_FAIL,
    payload: error,
});
